export const ApplePayConfigName = "applePay";
